import axios from 'axios'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const APIClient = axios.create({
  baseURL: 'http://localhost:8000',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const fetchPost = ({ service, postId, postType }) =>
  APIClient.get(`/${service}/${postType}/${postId}`, {
    params: {
      include: 'account,photo',
    },
  })

const getPost = (options) => (dispatch) =>
  fetchPost(options)
    .then((response) => {
      const body = response.data
      if (body.data) dispatch(loadJsonApiEntities(body))

      return body
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getPost
